<template>
    <div class="container py-4">
      <div class="hero">
      <div class="hero-content">
        <h1 class="hero-title">
          Ditch the Line. Boost Bar Sales.<br />Let Guests Order from Their Phone!
        </h1>
        <ScheduleDemo :signedIn="isSignedIn" />
      </div>
    </div>

    <div v-if="!isSignedIn" class="alert alert-primary text-center mt-4 mb-3" role="alert" style="background-color: #e6e0ff; color: #4f47c7; font-weight: 500;">
      <strong>VibeTap is currently free!</strong> Join as an early venue partner to help shape the future of VibeTap and unlock future discounts.
    </div>


    <!-- BUSINESS FEATURE CARDS SECTION -->
    <h2 v-if="!isSignedIn" class="text-center">What Can VibeTap Do for Your Venue?</h2>
    <div v-if="!isSignedIn" class="features">
      
      <div class="feature-card" v-for="(feature, index) in businessFeatures" :key="index">
        <div class="icon ms-4" v-html="feature.icon"></div>
        <div class="text-content">
          <h3 class="feature-title">{{ feature.title }}</h3>
          <p class="feature-description">{{ feature.description }}</p>
        </div>
      </div>
    </div>
    <h2 v-if="!isSignedIn" class="text-center my-2">What Can VibeTap Do for Your Customers?</h2>
    <!-- FEATURE CARDS SECTION -->
    <div v-if="!isSignedIn" class="features">
      <div class="feature-card" v-for="(feature, index) in features" :key="index">
        <div class="icon ms-4" v-html="feature.icon"></div>
        <div class="text-content">
          <h3 class="feature-title">{{ feature.title }}</h3>
          <p class="feature-description">{{ feature.description }}</p>
        </div>
      </div>
    </div>

    <div v-if="!isSignedIn"  class="text-center py-3 text-muted" style="font-size: 0.9rem;">
        Coming soon: Live DJ & Performer integrations, in-app messaging, and social games to keep the party going 🎶💬
      </div>



    <div class="row align-items-md-stretch">
      <div :class="isSignedIn ? 'col-md-6' : 'col-12'">
        <div v-if="!isSignedIn" class="try-vibetap-wrapper mb-4 rounded shadow-lg">
          <div class="qr-header-bar"></div>
          <div class="try-vibetap-content row g-0 align-items-center p-4">

            <!-- QR & Text Column -->
            <div class="col-lg-12 d-flex flex-column flex-lg-row align-items-center">
              <!-- Left: Text -->
              <div class="text-white pe-lg-5 mb-4 mb-lg-0 col-lg-6">
                <h2 class="fw-bold mb-3" style="font-size: 28px;">Try VibeTap Right Now</h2>
                <p>
                  See how your guests will experience VibeTap — right from their mobile device.
                  Our platform is built for seamless ordering and pickup at bars, clubs, and events.
                </p>

                <p>
                  Scan the QR code below to open a fully interactive preview of the app. You’ll be able to:
                </p>

                <ul>
                  <li>Browse a sample menu</li>
                  <li>Place a test order (pickup or table)</li>
                  <li>Receive a sample pickup notification</li>
                </ul>
                

                <p><strong>No downloads required</strong> — just scan and go.</p>

                 <p class="mt-3" >
                  <em>Download the full app to test the complete VibeTap experience!!</em>
                </p>
              </div>

              <!-- Right: QR Code -->
              <div class="text-center col-lg-6">
                <img
                  src="../assets/TestQRTable.jpg"
                  alt="Test VibeTap QR"
                  class="qr-img img-fluid mb-2"
                  style="max-width: 240px;"
                />
                <p class="text-secondary small">Scan with your phone camera or <a href="https://order.vibe-tap.com?tableID=685ba02ba9cdbe0255b40636" target="_blank" rel="noopener noreferrer"> click here</a> to test the experience</p>
              </div>
            </div>

          </div>
        </div>

        <div v-else-if="this.$store.state.venues.length===0" class="h-100 p-5 text-bg-dark rounded-3 mb-2">
          <h2>Setup and manage your business!!</h2>
          <p>We offer a free service to help you setup your business but you are free to setup the data yourself. Please click the link to see the instructions for bar setup and usage, or schedule a meeting with us below.</p>
         <router-link class="btn  btnAccent me-2" to="/Instructions">Instructions</router-link>
        </div>
        <div v-else class="metrics-container">
          <!-- Tab Buttons -->
          <div class="tab-selector">
            <button :class="{ active: selectedTab === 'daily' }" @click="selectedTab = 'daily'">Today</button>
            <button :class="{ active: selectedTab === 'monthly' }" @click="selectedTab = 'monthly'">This Month</button>
          </div>

          <div class="last-updated">
            <small>Last updated: {{ lastUpdated }}</small>
          </div>

          <!-- Metrics Card -->
          <div class="metrics-card-2x2 h-100 pt-5">
            <div class="metric">
              <h3>Revenue</h3>
              <p class="value">
                {{ selectedTab === 'daily' ? centsToDollars(metrics.totalRevenueByDay) : centsToDollars(metrics.totalRevenueMonth) }}
              </p>
            </div>

            <div class="metric">
              <h3>Total Orders</h3>
              <p class="value">
                {{ selectedTab === 'daily' ? metrics.totalOrdersToday : metrics.totalOrdersMonth }}
              </p>
            </div>

            <div class="metric">
              <h3>Avg Wait Time</h3>
              <p class="value">
                {{ displayWaitTime }}
              </p>
            </div>

            <div class="metric" v-if="stripeAccountCreated">
              <h3>Stripe Balance</h3>
              <p class="value">$ {{metrics.stripeTotal }}</p>
            </div>
          </div>
        </div>

      </div>
      <div v-if="isSignedIn" class="col-md-6 top-margin-mobile">
          <img class="image-visual mb-2 h-100 rounded-3" src="../assets/Visual.jpg" />
      </div>
    </div>
     <div v-if="isSignedIn && isBusiness" class="h-100 p-5 text-bg-dark rounded-3 mt-3">
        <EmployeeCode/>
      </div>

    <div class="h-100 p-5 rounded-3 contact-us mt-4">
           <h2>Contact Us</h2>

    <p>If you have any questions or need assistance, please feel free to contact us/schedule an appointment:</p>

    <p>
        <strong>Email:</strong> <a href="mailto:info@example.com">help@vibe-tap.com</a>
    </p>

    <p>
         <ScheduleDemo :signedIn="isSignedIn" />
    </p>

    <p>
        We're available to schedule appointments to set up your business data and provide software training. Please contact us to arrange a suitable time.
    </p>

    <p>We're here to help!</p>
        </div>

    <footer class="pt-3 mt-4 text-muted border-top">
      &copy; 2024
    </footer>
  </div>

</template>
<script>
import EmployeeCode from './EmployeeCode.vue';
import ScheduleDemo from '../components/ScheduleDemo.vue';

export default {
  components:{EmployeeCode,ScheduleDemo},
  name: 'MainLanding',
  props: {
    msg: String,
    reload:Boolean
  },
  data() {
    return {
     selectedTab:'daily',
     businessFeatures: [
      {
        icon: '<div class="col-4 description-box"><i class="ph-bold ph-ticket main-icon my-2"></i></div>',
        title: 'Custom Venue Setup',
        description: 'Easily configure your layout by adding bars/pickup locations, bathrooms, tables, and menus for each location. Tailor the app to match your space and flow of service.'
      },
      {
        icon: '<div class="col-4 description-box"><i class="ph-bold ph-palette main-icon my-2"></i></div>',
        title: 'Branded Theme Customization',
        description: "Customize colors, styling, and even upload your venue's logo to reflect your brand identity. Give guests a fully branded experience that looks and feels like your business."
      },
      {
        icon: '<div class="col-4 description-box"><i class="ph-bold ph-download-simple main-icon my-2"></i></div>',
        title: 'Menu Import via Photo',
        description: 'Save time by uploading a photo of your existing menu. Our system helps convert it into a clean, tappable format for guests to browse and order.'
      },
      {
          icon: '<div class="col-4 description-box"><i class="ph-bold ph-credit-card main-icon my-2"></i></div>',
          title: 'Flexible Payments',
          description: 'Use our service with or without in-app payments. Flexible to your needs.'
      },
      {
        icon: '<div class="col-4 description-box"><i class="ph-bold ph-qr-code main-icon my-2"></i></div>',
        title: 'QR Code Generation',
        description: 'Generate QR codes for your venue, tables, or bars in seconds. Print or share them anywhere to drive orders and simplify guest access.'
      }
    ],
     features: [
        {
          icon: '<div class="col-4 description-box"><i class="ph-bold ph-device-mobile main-icon my-2"></i></div>',
          title: 'Mobile Drink Ordering',
          description: "Let guests skip the line by ordering from their phone. They'll get a push or SMS alert as soon as it's accepted."
        },
        {
          icon: '<div class="col-4 description-box"><i class="ph-bold ph-martini main-icon my-2"></i></div>',
          title: 'VIP Menu & Table Order',
          description: 'Serve guests right at their table with exclusive VIP menus and private ordering—perfect for bottle service or special events.'
        },
        { 
          icon: '<div class="col-4 description-box"><i class="ph-bold ph-user-circle main-icon my-2"></i></div>',
          title: 'Contact Security / Friends',
          description: 'Easily alert security or send the venue address to friends.'
        },
        {
          icon: '<div class="col-4 description-box"><i class="ph-bold ph-lightning main-icon my-2"></i></div>',
          title: 'Fastest Pickup',
          description: 'Send orders to all available bars/pick-up locations— increase order completion speed'
        }
      ]
    };
  },
  async mounted(){
   if(!this.$store.state.loadedVenues && this.isSignedIn){
       await this.$store.dispatch('venueLookup')
    }

   if(!this.$store.state.metrics && this.isSignedIn){
      await this.$store.dispatch('fetchMetrics')
    }
  },
  methods: {
  centsToDollars(cents) {
    if (typeof cents !== 'number') return '$0.00';
    return `$ ${(cents / 100).toFixed(2)}`;
  }
},
  computed:{
    isSignedIn(){
      return sessionStorage.getItem('token')!=null;
    },
    isBusiness(){
      return sessionStorage.getItem('isBusiness') === "true";
    },
    stripeAccountCreated(){
      return sessionStorage.getItem('stripeAccountCreated') === "true";
    },
    metrics() {
      return this.$store.state.metrics;
    },
    lastUpdated() {
      const timestamp = this.$store.state.lastMetricsUpdate;
      return timestamp
        ? new Date(timestamp).toLocaleString([], { dateStyle: 'short', timeStyle: 'short' })
        : 'Not available';
    },
    displayWaitTime() {
      const timeObj =
        this.selectedTab === 'daily'
          ? this.metrics?.avgCompletionTimeToday
          : this.metrics?.avgCompletionTimeMonth;

      return timeObj ? `${timeObj.minutes}m ${timeObj.seconds}s` : 'N/A';
    }
  }
}
</script> 

<style scoped>
.try-vibetap-wrapper {
  background-color: #1e1e1e;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.4);
}

.qr-header-bar {
  height: 4px;
  background: linear-gradient(90deg, #83548C, #C08DF4);
}

.qr-img {
  max-width: 280px;
  border-radius: 8px;
}
.hero {
  background: linear-gradient(.25turn, rgba(12, 14, 22, 0.5), rgba(172, 7, 197, 0.5)),
              url("../assets/PulseB2.jpg") center/cover no-repeat;
  height: 500px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin-bottom: 32px;
}

.hero-content {
  color: white;
  max-width: 90%;
}

.hero-title {
  font-size: 36px;
  line-height: 1.4;
  text-transform: uppercase;
  margin-bottom: 16px;
}

.hero-button {
  background-color: black;
  color: white;
  font-size: 16px;
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
}

.features {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 24px;
  padding: 32px;
}

.feature-card {
  display: flex;
  align-items: flex-start;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.icon {
  font-size: 36px;

}

.text-content {
  flex: 1;
}

.feature-title {
  font-size: 18px;
  margin-bottom: 6px;
  font-weight: bold;
}

.feature-description {
  font-size: 14px;
  color: #444;
}
.metrics-card-2x2 {
  background-color: #1f1f1f;
  border-radius: 12px;
  padding: 24px;
  color: white;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  max-width: 100%;
  text-align: center;
}
.metric h5 {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
}

.value {
  font-size: 2rem;
  font-weight: bold;
  margin-top: 6px;
}
.tab-selector {
  display: flex;
  gap: 12px;
  margin-bottom: 1rem;
}

.tab-selector button {
  padding: 8px 16px;
  border: none;
  background: #eee;
  cursor: pointer;
}

.tab-selector button.active {
  background: #83548C;
  color: white;
  font-weight: bold;
  border-radius: 6px;
}
.last-updated {
  margin-bottom: 0.5rem;
  text-align: right;
  font-size: 0.85rem;
  color: #777;
}
</style>